"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tweetnacl_util_1 = require("tweetnacl-util");
var crypto_1 = require("./util/crypto");
var validate_1 = require("./util/validate");
var crypto_base_1 = __importDefault(require("./crypto-base"));
var CryptoV3 = /** @class */ (function (_super) {
    __extends(CryptoV3, _super);
    function CryptoV3() {
        var _this = _super.call(this) || this;
        /**
         * Encrypt input with a unique keypair for each submission.
         * @param msg The message to encrypt, will be stringified.
         * @param form The base-64 encoded form public key for encrypting.
         * @returns The encrypted basestring.
         */
        _this.encrypt = function (msg, formPublicKey) {
            var submissionKeypair = (0, crypto_1.generateKeypair)();
            var encryptedSubmissionSecretKey = (0, crypto_1.encryptMessage)((0, tweetnacl_util_1.decodeBase64)(submissionKeypair.secretKey), formPublicKey);
            var processedMsg = (0, tweetnacl_util_1.decodeUTF8)(JSON.stringify(msg));
            var encryptedContent = (0, crypto_1.encryptMessage)(processedMsg, submissionKeypair.publicKey);
            return {
                submissionPublicKey: submissionKeypair.publicKey,
                submissionSecretKey: submissionKeypair.secretKey,
                encryptedContent: encryptedContent,
                encryptedSubmissionSecretKey: encryptedSubmissionSecretKey,
            };
        };
        /**
         * Decrypts an encrypted submission and returns it.
         * @param submissionSecretKey The base-64 encoded secret key for decrypting.
         * @param decryptParams The params containing encrypted content and information.
         * @param decryptParams.encryptedContent The encrypted content encoded with base-64.
         * @param decryptParams.version The version of the payload.
         * @returns The decrypted content if successful. Else, null will be returned.
         */
        _this.decryptFromSubmissionKey = function (submissionSecretKey, decryptParams) {
            try {
                var encryptedContent = decryptParams.encryptedContent;
                // Do not return the transformed object in `_decrypt` function as a signed
                // object is not encoded in UTF8 and is encoded in Base-64 instead.
                var decryptedContent = (0, crypto_1.decryptContent)(submissionSecretKey, encryptedContent);
                if (!decryptedContent) {
                    throw new Error('Failed to decrypt content');
                }
                var decryptedObject = JSON.parse((0, tweetnacl_util_1.encodeUTF8)(decryptedContent));
                if (!(0, validate_1.determineIsFormFieldsV3)(decryptedObject)) {
                    throw new Error('Decrypted object does not fit expected shape');
                }
                var returnedObject = {
                    submissionSecretKey: submissionSecretKey,
                    responses: decryptedObject,
                };
                return returnedObject;
            }
            catch (err) {
                return null;
            }
        };
        /**
         * Decrypts an encrypted submission and returns it.
         * @param formSecretKey The base-64 encoded form secret key for decrypting the submission.
         * @param decryptParams The params containing encrypted content, encrypted submission key and information.
         * @param decryptParams.encryptedContent The encrypted content encoded with base-64.
         * @param decryptParams.encryptedSubmissionSecretKey The encrypted submission secret key encoded with base-64.
         * @param decryptParams.version The version of the payload. Used to determine the decryption process to decrypt the content with.
         * @returns The decrypted content if successful. Else, null will be returned.
         */
        _this.decrypt = function (formSecretKey, decryptParams) {
            var encryptedSubmissionSecretKey = decryptParams.encryptedSubmissionSecretKey, rest = __rest(decryptParams, ["encryptedSubmissionSecretKey"]);
            var submissionSecretKey = (0, crypto_1.decryptContent)(formSecretKey, encryptedSubmissionSecretKey);
            if (submissionSecretKey === null)
                return null;
            return _this.decryptFromSubmissionKey((0, tweetnacl_util_1.encodeBase64)(submissionSecretKey), rest);
        };
        /**
         * Returns true if a pair of public & secret keys are associated with each other
         * @param publicKey The public key to verify against.
         * @param secretKey The private key to verify against.
         */
        _this.valid = function (publicKey, secretKey) {
            var _a;
            var testResponse = {};
            var internalValidationVersion = 3;
            var cipherResponse = _this.encrypt(testResponse, publicKey);
            // Use toString here since the return should be an empty array.
            return (testResponse.toString() ===
                ((_a = _this.decrypt(secretKey, __assign(__assign({}, cipherResponse), { version: internalValidationVersion }))) === null || _a === void 0 ? void 0 : _a.responses.toString()));
        };
        return _this;
    }
    return CryptoV3;
}(crypto_base_1.default));
exports.default = CryptoV3;
